export const AUTH_FAILED_MESSAGE = 'Durchwahl oder Passwort falsch – ist für diese Durchwahl WebRTC freigeschaltet?';
export const MIC_DENIED_MESSAGE = 'Kein Mikrofonzugriff – bitte im Browser erlauben.';
export const DISCONNECTED_MESSAGE = 'Verbindung getrennt – verbinde neu …';

const SILENT = new Set(['Terminated', 'Canceled', 'Rejected', 'Busy Here']);

export function endCauseMessage(cause: string | undefined, direction: 'in' | 'out'): string | null {
  if (!cause || SILENT.has(cause)) return null;
  if (cause === 'User Denied Media Access') return MIC_DENIED_MESSAGE;
  if (direction === 'in') return null;
  switch (cause) {
    case 'Busy':
      return 'Besetzt';
    case 'Unavailable':
    case 'Not Found':
      return 'Nicht erreichbar';
    case 'No Answer':
      return 'Keine Antwort';
    default:
      return 'Anruf fehlgeschlagen';
  }
}
